var exports = {
  "a": "x234b8571--5b8303--slider",
  "x": "x234b8571--5b8303--slider-list",
};

module.exports = exports;
